document.addEventListener("DOMContentLoaded", function () {

    window.addEventListener("load", function () {

        const containers = document.querySelectorAll(".beforeAfterSlider");

        containers.forEach(function (container) {

            let isMobile = window.matchMedia("(max-width: 1100px)").matches;

            window.addEventListener("resize", () => {
                isMobile = window.matchMedia("(max-width: 1100px)").matches;
            });


            /************************************************
             * BEFORE / AFTER
             ************************************************/

            const imageWraps = container.querySelectorAll(".wrap.images");

            imageWraps.forEach(function (wrap) {

                const scrollerMiddle = wrap.querySelector(".scroller-middle");
                const middle = wrap.querySelector(".middle");

                if (!scrollerMiddle || !middle) return;

                middle.style.width = "50%";
                scrollerMiddle.style.left = "50%";
            });


            let active = false;
            let activeWrap = null;
            let activeMiddle = null;
            let activeScroller = null;


            function scrollIt(x) {

                if (!activeWrap || !activeMiddle || !activeScroller) return;

                const wrapWidth = activeWrap.offsetWidth;
                const scrollerWidth = activeScroller.offsetWidth;
                const maxPixel = wrapWidth - scrollerWidth;

                const minMobileMax = wrapWidth * 0.8;

                const allowedMax = isMobile
                    ? Math.max(maxPixel, minMobileMax)
                    : maxPixel;

                const clamped = Math.max(
                    0,
                    Math.min(x, allowedMax)
                );

                const percent = (clamped / wrapWidth) * 100;

                activeMiddle.style.width = percent + "%";
                activeScroller.style.left = percent + "%";
            }


            function startDrag(e) {

                const scroller = e.target.closest(".scroller-middle");

                if (!scroller || !container.contains(scroller)) {
                    return;
                }

                const wrap = scroller.closest(".wrap.images");

                if (!wrap) {
                    return;
                }

                activeWrap = wrap;
                activeScroller = scroller;
                activeMiddle = wrap.querySelector(".middle");

                if (!activeMiddle) {
                    return;
                }

                active = true;

                scroller.classList.add("scrolling");

                scroller.style.zIndex = 3;

                e.stopPropagation();
            }


            container.addEventListener(
                "mousedown",
                startDrag,
                { capture: true }
            );

            container.addEventListener(
                "touchstart",
                startDrag,
                { capture: true, passive: true }
            );


            const stopAll = () => {

                if (!active) return;

                active = false;

                if (activeScroller) {
                    activeScroller.classList.remove("scrolling");
                    activeScroller.style.zIndex = "";
                }

                activeWrap = null;
                activeMiddle = null;
                activeScroller = null;
            };


            ["mouseup", "mouseleave", "touchend", "touchcancel"].forEach(
                (event) => {
                    document.body.addEventListener(event, stopAll);
                }
            );


            document.body.addEventListener("mousemove", function (e) {

                if (!active || !activeWrap) return;

                const rect = activeWrap.getBoundingClientRect();

                const x = e.pageX - rect.left;

                scrollIt(x);
            });


            container.addEventListener(
                "touchmove",
                function (e) {

                    if (!active || !activeWrap) return;

                    e.preventDefault();

                    const rect = activeWrap.getBoundingClientRect();

                    const x =
                        e.touches[0].pageX - rect.left;

                    scrollIt(x);
                },
                { passive: false }
            );


            /************************************************
             * SWIPER
             ************************************************/

            const mainEl = container.querySelector(".swiper.main");
            const thumbsEl = container.querySelector(".swiper.thumbs");

            if (mainEl && thumbsEl) {

                let isDesktop = window.matchMedia(
                    "(min-width: 1100px)"
                ).matches;


                /************************************************
                 * THUMBS SWIPER
                 ************************************************/

                const galleryThumbs = new Swiper(thumbsEl, {
                    spaceBetween: 0,
                    slidesPerView: "auto",
                    loop: false,
                    freeMode: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    direction: isDesktop
                        ? "vertical"
                        : "horizontal",
                });


                /************************************************
                 * MAIN SWIPER
                 ************************************************/

                const galleryTop = new Swiper(mainEl, {

                    spaceBetween: 10,
                    loop: false,
                    allowTouchMove: false,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    noSwipingClass: "swiper-no-swiping",
                    thumbs: {
                        swiper: galleryThumbs
                    },
                    on: {

                        init: function () {

                            setActiveSlide(this);

                        },

                        slideChange: function () {

                            setActiveSlide(this);

                        },

                        slideChangeTransitionStart: function () {

                            setActiveSlide(this);

                        }
                    }
                });


                /************************************************
                 * ACTIVE SLIDE
                 ************************************************/

                function setActiveSlide(swiper) {

                    swiper.slides.forEach(function (slide, index) {

                        slide.classList.remove(
                            "before-after-active"
                        );

                        slide.style.zIndex = "";

                    });


                    const activeSlide =
                        swiper.slides[swiper.activeIndex];

                    if (!activeSlide) return;


                    activeSlide.classList.add(
                        "before-after-active"
                    );

                    activeSlide.style.zIndex = 2;

                    const activeWrap =
                        activeSlide.querySelector(".wrap.images");

                    if (activeWrap) {

                        const middle =
                            activeWrap.querySelector(".middle");

                        const scroller =
                            activeWrap.querySelector(".scroller-middle");

                        if (middle && scroller) {

                            middle.style.width = "50%";
                            scroller.style.left = "50%";

                        }
                    }
                }


                /************************************************
                 * RESIZE
                 ************************************************/

                window.addEventListener("resize", function () {

                    const newIsDesktop =
                        window.matchMedia(
                            "(min-width: 1100px)"
                        ).matches;

                    if (newIsDesktop === isDesktop) return;

                    isDesktop = newIsDesktop;

                    /*
                     * Swiper-Richtung aktualisieren
                     */
                    galleryThumbs.changeDirection(
                        isDesktop
                            ? "vertical"
                            : "horizontal"
                    );

                    galleryThumbs.update();
                    galleryTop.update();

                    setActiveSlide(galleryTop);
                });

            }

        });

    });

});
